<template>
  <div class="checkpoint-level-dropdown-cell" data-testid="checkpoint-level-dropdown-cell">
    <CheckpointLevelBanner :level="level" :disabled="disabled" @change="onChange" />
  </div>
</template>

<script setup>
import CheckpointLevelBanner, {
  isCheckpointLevelValue,
} from "@components/CheckpointLevelBanner/CheckpointLevelBanner.vue";

defineProps({
  level: {
    type: String,
    default: "Apprentice",
    validator: isCheckpointLevelValue,
  },
  /** Suppresses the dropdown affordance (e.g. rows the operator cannot edit). */
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["change"]);

function onChange(nextLevel) {
  if (!isCheckpointLevelValue(nextLevel)) return;
  emit("change", nextLevel);
}
</script>

<style scoped>
.checkpoint-level-dropdown-cell {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 36px;
  position: relative;
  box-sizing: border-box;
}

.checkpoint-level-dropdown-cell :deep(.checkpoint-level-banner) {
  width: 100%;
  min-width: 0;
  height: 36px;
  padding: 5px 10px;
}

.checkpoint-level-dropdown-cell :deep(.checkpoint-level-banner__selector) {
  gap: 4px;
}
</style>
